import axios from "axios";

export default {
  namespaced: true,
  state: {
    chats: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    chatMessage: '',
    chatChannel: null,
    chatChannels: ['Sales Data Assistant', 'Purchase Data Assistant'],
  },
  mutations: {
    CLEAR_CHATS(state) {
      state.chats = [];
    },
    POP_FIRST(state) {
      state.chats.shift();
    },
    SET_CHANNEL(state, payload) {
      state.chatChannel = payload.channel;
    },
    INIT_CHANNEL(state) {
      if(state.chatChannel==null || state.chatChannel=='') state.chatChannel = state.chatChannels[0];
    },
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_CHATS(state, payload) {
      state.chats = payload;
      state.isReceiving = false;
    },
    RECEIVING_CHATS(state) {
      state.isReceiving = true;
    },
    RECEIVED_CHAT(state, payload) {
      state = Object.assign(state, {
        chats: [payload, ...state.chats],
        isReceiving: false,
      })
    },
    RECEIVING(state) {
      state.isReceiving = true;
    },
    UPDATED_CHATS(state, payload) {
      let index = state.chats.findIndex(chat => chat._id === payload._id);
      state = Object.assign(state, {
        chats: state.chats.map((chat, i) => {
          if (i === index) {
            return Object.assign({}, chat, payload);
          }
          return chat;
        }),
        isUpdating: false,
        chatMessage: 'Chats has been updating!',
      })
    },
    UPDATING_CHATS(state) {
      state.isUpdating = true;
    },
    DELETED_CHATS(state, payload) {
      let indexToDelete = state.chats.findIndex(chat => chat._id === payload._id);
      let chats = [...state.chats];
      chats.splice(indexToDelete, 1);
      state = Object.assign(state, {
        chats: [...chats],
        isDeleting: false,
        idToDelete: null,
        chatMessage: 'Chat has been Deleted!',
      });
    },
    DELETING_CHATS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getChatsRequest({dispatch}) {
      dispatch("receivingChats");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/chats';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        console.log(res.data)
        dispatch("receiveChats", res.data);
      })
    },
    getSalesGreetingRequest({dispatch}) {
      dispatch("receivingChats");
      let url = 'https://api.chatxc.com/py/chat/sales/greeting';
      let headers = {'Content-Type': 'application/json','Authorization': 'bP02#J#giCr0p5RUsW$-*cRlZ&+hUW$10b+N8$8_#=7?93E0r2yiNA2Lra*iB@Ami'};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        let chat = res.data;
        chat.chatimage = chat.chatimage!=null ? chat.chatimage : require('@/assets/tradexc_icon_logo.png'),
        dispatch("receiveChat", chat);
      })
    },
    getPurchaseGreetingRequest({dispatch}) {
      dispatch("receivingChats");
      let url = 'https://api.chatxc.com/py/chat/purchase/greeting';
      let headers = {'Content-Type': 'application/json','Authorization': 'bP02#J#giCr0p5RUsW$-*cRlZ&+hUW$10b+N8$8_#=7?93E0r2yiNA2Lra*iB@Ami'};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        let chat = res.data;
        chat.chatimage = chat.chatimage!=null ? chat.chatimage : require('@/assets/tradexc_icon_logo.png'),
        dispatch("receiveChat", chat);
      })
    },
    getSalesQueryRequest({dispatch}, payload) {
      dispatch("receivingChats");
      let companyid = localStorage.getItem('companyid');
      payload.companyid = companyid;
      let url = 'https://api.chatxc.com/py/chat/sales/query/prompt';
      let headers = {'Content-Type': 'application/json','Authorization': 'bP02#J#giCr0p5RUsW$-*cRlZ&+hUW$10b+N8$8_#=7?93E0r2yiNA2Lra*iB@Ami'};
      let image = localStorage.getItem('userimage');
      let name = localStorage.getItem('username');
      
      let post = {chattext: payload.prompttext, chatimage: image, chatname: name, chattype: 'user'};
      dispatch("receiveChat", post);
      dispatch("insertChatRequest", post);
      axios({method: "POST", url: url, headers: headers, data: payload})
      .then(res => {
        let chat = res.data;
        chat.chatimage = chat.chatimage!=null ? chat.chatimage : require('@/assets/tradexc_icon_logo.png'),
        dispatch("receiveChat", chat);
        dispatch("insertChatRequest", chat);
      })
    },
    getPurchaseQueryRequest({dispatch}, payload) {
      dispatch("receivingChats");
      let companyid = localStorage.getItem('companyid');
      payload.companyid = companyid;
      let url = 'https://api.chatxc.com/py/chat/purchase/query/prompt';
      let headers = {'Content-Type': 'application/json','Authorization': 'bP02#J#giCr0p5RUsW$-*cRlZ&+hUW$10b+N8$8_#=7?93E0r2yiNA2Lra*iB@Ami'};
      let image = localStorage.getItem('userimage');
      let name = localStorage.getItem('username');
      let post = {chattext: payload.prompttext, chatimage: image, chatname: name, chattype: 'user'};
      dispatch("receiveChat", post);
      dispatch("insertChatRequest", post);
      axios({method: "POST", url: url, headers: headers, data: payload})
      .then(res => {
        let chat = res.data;
        if(chat.error==null) {
          chat.chatimage = chat.chatimage!=null ? chat.chatimage : require('@/assets/tradexc_icon_logo.png'),
          dispatch("receiveChat", chat);
          dispatch("insertChatRequest", chat);
        } 
      })
    },
    async insertChatRequest({dispatch}, payload) {
      dispatch("doNothing");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/chat/';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      let response = await axios({method: "post", url: url, headers: headers , data: payload});
      return response.data;
    },


    clearChats({commit}) {
      commit("CLEAR_CHATS")
    },
    setChatChannel({commit}, payload) {
      commit("SET_CHANNEL", payload)
    },
    popChatsFirst({commit}) {
      commit("POP_FIRST")
    },
    initChatChannel({commit}) {
      commit("INIT_CHANNEL");
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveChats({commit}, payload) {
      commit("RECEIVED_CHATS", payload)
    },
    receivingChats({commit}) {
      commit("RECEIVING_CHATS")
    },
    receiveChat({commit}, payload) {
      commit("RECEIVED_CHAT", payload)
    },
    receivingChat({commit}) {
      commit("RECEIVING_CHATS")
    },
    updateChat({commit}, payload) {
      commit("UPDATED_CHATS", payload)
    },
    updatingChat({commit}) {
      commit("UPDATING_CHATS")
    },
    deleteChat({commit}, payload) {
      commit("DELETED_CHATS", payload)
    },
    deletingChat({commit}, payload) {
      commit("DELETING_CHATS", payload)
    }
  },
};
